import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class LoginModel {
    private static sInstance: LoginModel;

    public static get instance(): LoginModel {
        if (!LoginModel.sInstance) {
            LoginModel.sInstance = new LoginModel();
        }

        return LoginModel.sInstance;
    }

    public async getCaptcha(
        query: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/captcha/get",
            "post",
            query,
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }  

    public async checkCode(
        query: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/captcha/valid",
            "post",
            query
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async login(
        loginQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.Response> {
        let responseInfo = TCBReceiptApi.Protobuf.Response.create();

        await Network.sendAPI(
            "/api/web_user/login",
            "post",
            loginQuery,
        )
        .then(rawResponse => {
            const response = TCBReceiptApi.Protobuf.Response.decode(
                new Uint8Array(rawResponse.data as ArrayBufferLike)
            );

            responseInfo = response;
        })
        .catch(error => {
            Log.error(error);
        });

        return responseInfo;
    }

    public async forget(
        query: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/forget_password",
            "post",
            query
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async firstResetPassword(
        query: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/first_reset_password",
            "post",
            query
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async continuePassword(): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/continue_password",
            "post",
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async updatePermission(): Promise<TCBReceiptApi.Protobuf.UserAuth> {
        let info = TCBReceiptApi.Protobuf.UserAuth.create();
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/update_permission",
            "post",
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                info = TCBReceiptApi.Protobuf.UserAuth.decode(
                    new Uint8Array(response.item)
                );
                ec = response.errorCode;
                if (ec === TCBReceiptApi.Protobuf.ErrorCode.EC_USER_REPEAT_LOGIN) {
                    alert("此帳號已從其他地方登入，您已被登出");
                    window.location.href = "/login";
                }

                if (ec === TCBReceiptApi.Protobuf.ErrorCode.EC_USER_TOKEN_EXPIRES || rawResponse.status === 401) {
                    alert("帳號驗證失敗，請重新登入");
                    window.location.href = "/login";
                }
            })
            .catch((error) => {
                Log.error(error);
            });

        return info;
    }    

    public async checkResetPasswordPeriod(): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/check_reset_password_period",
            "post",
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }    

    public async resetPassword(
        query: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/web_user/reset_password",
            "post",
            query
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }  
    
    public async logout(): Promise<void> {
        await Network.sendAPI(
            "/api/web_user/logout",
            "post",
        )
    }

    // 檢查當下token並延長至時間上限
    public async CheckAndUpdateAndGetOnline(): Promise<[TCBReceiptApi.Protobuf.ErrorCode, number]> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;
        let info = TCBReceiptApi.Protobuf.UserAuth.create();
        let expireTime = 0;

        await Network.sendAPI(
            "/api/web_user/check_and_update_and_get_online",
            "post",
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
                info = TCBReceiptApi.Protobuf.UserAuth.decode(
                    new Uint8Array(response.item)
                );
                expireTime = info.expireTime as number;
                console.log(response);
            })
            .catch((error) => {
                Log.error(error);
            });


        return [ec, expireTime];
    } 
}

const loginModel = LoginModel.instance;

export { loginModel as LoginModel };
